
<div class="inicio">
    
    <form #insertForm="ngForm" [formGroup]="formAsignacionDiecta">
            
        <div class="grid-container5">
            
            <button mat-mini-fab color="accent" matTooltip="Cancelas el proceso de asignación" (click)="cancelar($event)" ><mat-icon style="transform: rotate(180deg);">forward icon</mat-icon></button>
            <div></div>
            <p class="titulo">
                ASIGNACIÓN DE EQUIPO CON SOLICITUD
                <button mat-mini-fab color="primary" matTooltip="Click para más información" (click)="clickMasInformacion($event)" >
                    <mat-icon>info</mat-icon> 
                </button>
            </p>
            <div></div>
            <div></div>
            
        </div>

        
        <!--Nombre del colaborador-->
        <div class="grid-container3">

            <div class="celda">
                <mat-label class="label">Nombre colaborador</mat-label>
                <mat-label class="txt">{{formAsignacionDiecta.value.colaborador_name}}</mat-label>
            </div>
            
            <div class="celda">
                <mat-label class="label"> Cargo </mat-label>
                <mat-label class="txt"> {{formAsignacionDiecta.value.cargo_name}} </mat-label>
            </div>

            <div class="celda">
                <mat-label class="label"> Oficina </mat-label>
                <mat-label class="txt"> {{formAsignacionDiecta.value.sucursal_name}} </mat-label>
            </div>

            <div class="celda">
                <mat-label class="label">Tipo de equipo:</mat-label>
                <mat-label class="txt">{{formAsignacionDiecta.value.activo}}</mat-label>
            </div>

            <div class="celda">
                <mat-label class="label">Descripción del uso o del equipo:</mat-label>
                <mat-label class="txt">{{descripcion}}</mat-label>
            </div>
        </div>
        <br>
        

            
        <div>

            <div class="grid-container">
                <mat-form-field appearance="fill" floatLabel="always">
                    <mat-label>Buscar</mat-label>
                    <input matInput (keyup)="filtroDataDource($event)"  placeholder="Ingrese el dato a buscar">
                </mat-form-field>
            </div>

            <!--Tabla-->
            <table mat-table [dataSource] = "dataSource"  class="mat-elevation-z8">

                <!-- Position Column -->
                <ng-container matColumnDef="OPCIONES">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> </th>
                    <td mat-cell *matCellDef="let element">
                        <button mat-mini-fab color="primary" matTooltip="Para asignar este equipo debes dar click" (click)="asignarEquipo(element.id,element.tipo,element.name, element.comment)"> <mat-icon>check_circle</mat-icon> </button>
                    </td>
                </ng-container>

                <!-- Name Column -->
                <ng-container matColumnDef="NOMBRE">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> NOMBRE </th>
                    <td mat-cell *matCellDef="let element"> {{element.name}} </td>
                </ng-container>
                
                <!-- Name Column -->
                <ng-container matColumnDef="NÚMERO DE SERIE">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> NÚMERO DE SERIE </th>
                    <td mat-cell *matCellDef="let element"> {{element.serial}} </td>
                </ng-container>

                <!-- Name Column -->
                <ng-container matColumnDef="TIPO">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> TIPO </th>
                    <td mat-cell *matCellDef="let element"> {{element.tipo}} </td>
                </ng-container>

                <!-- Name Column -->
                <ng-container matColumnDef="MODELO">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> MODELO </th>
                    <td mat-cell *matCellDef="let element"> {{element.modelo}} </td>
                </ng-container>

                <!-- Name Column -->
                <ng-container matColumnDef="FABRICANTE">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> FABRICANTE </th>
                    <td mat-cell *matCellDef="let element"> {{element.manufacturers_id}} </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="encabezadostabla"></tr>
                <tr mat-row *matRowDef="let row; columns: encabezadostabla;"></tr>
            
            </table>
            <mat-paginator class="mat-elevation-z8" [pageSizeOptions]="[10, 20, 30, 40, 50]" showFirstLastButtons></mat-paginator>    

        </div>

        
    </form>
</div>